/**
 * @format
 * @module ui/take-a-break
 */
import { breakpoints } from "utils/detect";
import logger from "utils/logger";
import { qs, qsa } from "utils/utils";

const debugTag = "[TAKE-A-BREAK]";

/**
 * Toggles visibility of features and/or cards when the viewport resizes
 * @param {Array<HTMLElement>} features
 * @param {Boolean} isWide
 */
function onViewportResize(features, isWide) {
  logger.info(`${debugTag} onViewportResize: ${isWide}`);
  toggleCardVisibility(features, isWide);
  adjustCardAnalytics(features);
  let action;

  // If multiple instances of the feature exist on the page, toggle their
  // visibility based on the current viewport width
  if (features.length > 1) {
    features.forEach(feature => {
      if (feature.closest(".secondary-content--section")) {
        // Right rail
        action = isWide ? "remove" : "add";
        feature.classList[action]("u-hidden");
      } else {
        // Page body
        action = isWide ? "add" : "remove";
        feature.classList[action]("u-hidden");
      }
    });
  }
}

/**
 * Toggles visibility of first card in each feature, based on viewport width
 * @param {Array<HTMLElement>} features
 * @param {Boolean} isWide
 */
function toggleCardVisibility(features, isWide) {
  const action = isWide ? "remove" : "add";
  features.forEach(feature => {
    const firstCard = qs(".c-break-package__card:first-child", feature);
    firstCard && firstCard.classList[action]("u-hidden");
  });
}

/**
 * Adjusts the analytics "position" value for each card in each feature,
 * based on whether the first card is visible
 * @param {Array<HTMLElement>} features
 */
function adjustCardAnalytics(features) {
  features.forEach(feature => {
    const cards = qsa(".c-break-package__card", feature);
    cards
      .filter(card => !card.classList.contains("u-hidden"))
      .forEach((card, index) => {
        if (!card.dataset.analyticsclick) {
          return;
        }
        const analytics = JSON.parse(card.dataset.analyticsclick);
        analytics.position = index + 1;
        card.dataset.analyticsclick = JSON.stringify(analytics);
      });
  });
}

/**
 * Initializes the "take a break" puzzle package feature
 */
export default function takeABreakInit() {
  const features = qsa(".c-break-package");
  if (!features.length) {
    return;
  }
  logger.info(`${debugTag} Init`, features);

  const mqList = window.matchMedia(`(min-width: ${breakpoints.tabletMedium.rem}rem)`);
  // TODO: change this to addEventListener when we drop support for IE
  // See: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
  if (mqList.addEventListener) {
    mqList.addEventListener("change", e => onViewportResize(features, e.matches));
  } else {
    mqList.addListener(e => onViewportResize(features, e.matches));
  }
  onViewportResize(features, mqList.matches);
}
